import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-contact-tooltip',
  templateUrl: './contact-tooltip.component.html',
  styleUrls: ['./contact-tooltip.component.scss']
})
export class ContactTooltipComponent implements OnInit {
  @Input() documents: string[];
  constructor() {}

  ngOnInit() {}
}
